/**
 * package: com.inq.flash.messagingframework
 * class: AbstractMessageHandler
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.AbstractMessageHandler = function(messageType) {
	this.messageType = messageType;
};
$hxClasses['com.inq.flash.messagingframework.AbstractMessageHandler'] = com.inq.flash.messagingframework.AbstractMessageHandler;
/** @private @type {Array} */
com.inq.flash.messagingframework.AbstractMessageHandler.__name__ = ["com","inq","flash","messagingframework","AbstractMessageHandler"];

/**
 * getMessagingFramework
 *
 * $type TFun([],TInst(com.inq.flash.messagingframework.FlashMessagingFramework,[]))
 * public function getMessagingFramework():FlashMessagingFramework
 * @public
 * @this com.inq.flash.messagingframework.AbstractMessageHandler
 * @return {com.inq.flash.messagingframework.FlashMessagingFramework}
 */
com.inq.flash.messagingframework.AbstractMessageHandler.prototype.getMessagingFramework = function() {
	return this.framework;
};


/**
 * setMessagingFramework
 *
 * $type TFun([{ name => framework, t => TInst(com.inq.flash.messagingframework.FlashMessagingFramework,[]), opt => false }],TEnum(Void,[]))
 * public function setMessagingFramework(framework:FlashMessagingFramework):Void
 * @public
 * @this com.inq.flash.messagingframework.AbstractMessageHandler
 * @param {com.inq.flash.messagingframework.FlashMessagingFramework}  framework 
 * @return {void}
 */
com.inq.flash.messagingframework.AbstractMessageHandler.prototype.setMessagingFramework = function(framework) {
	this.framework = framework;
};


/**
 * getMessageType
 *
 * $type TFun([],TInst(String,[]))
 * public function getMessageType():String
 * @public
 * @this com.inq.flash.messagingframework.AbstractMessageHandler
 * @return {string}
 */
com.inq.flash.messagingframework.AbstractMessageHandler.prototype.getMessageType = function() {
	return this.messageType;
};


/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * public function processMessage(message:Message):Void
 * @public
 * @this com.inq.flash.messagingframework.AbstractMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.messagingframework.AbstractMessageHandler.prototype.processMessage = function(message) {
};

/** @private @type {com.inq.flash.messagingframework.FlashMessagingFramework} */
com.inq.flash.messagingframework.AbstractMessageHandler.prototype.framework = null;
/** @private @type {string} */
com.inq.flash.messagingframework.AbstractMessageHandler.prototype.messageType = null;
/** @type {com.inq.flash.messagingframework.AbstractMessageHandler} */
com.inq.flash.messagingframework.AbstractMessageHandler.prototype.__class__ = com.inq.flash.messagingframework.AbstractMessageHandler;
